// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__H7e0a","container":"Footer_container__P4bsm","links":"Footer_links__HGLjL","link":"Footer_link__FaSPg","copyright":"Footer_copyright__EPfjp"};